import { LngLatBounds } from 'mapbox-gl';

export default class lngLatBounds {
  #bounds
  constructor(latitude, longitude) {
    this.createBounds({ lat: latitude, lng: longitude });
  }

  createBounds() {
    this.#bounds = new LngLatBounds();
  }

  add(latLng) {
    this.#bounds.extend(latLng);
  }

  get() {
    return this.#bounds;
  }
}
